module.exports = __webpack_public_path__ + "img/logo.42715d11.svg";